import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm5.32,12.38L9.6,18.82a.5.5,0,0,1-.82-.39V15.74A.49.49,0,0,1,9,15.35l4-3.15a.25.25,0,0,0,0-.4L9,8.65a.49.49,0,0,1-.19-.39V5.57a.5.5,0,0,1,.82-.39l7.72,6.44A.49.49,0,0,1,17.32,12.38Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }